export const SET_CATEGORY_DETAILS = 'SET_CATEGORY_DETAILS';
